import { useState } from "react";
import { Info } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const METRIC_HELP = {
  inflow: {
    title: "Entró a bancos",
    body: "Dinero que ingresó a tus cuentas durante el mes: cobros de ventas, depósitos manuales y abonos. Los dólares se convierten a pesos al tipo de cambio de Ajustes. No incluye transferencias entre tus propias cuentas.",
  },
  outflow: {
    title: "Salió de bancos",
    body: "Todo el dinero que salió de tus cuentas en el mes, sin importar el motivo: gastos pagados desde un banco, retiros manuales y devoluciones o reversiones de cobros. No incluye transferencias entre tus propias cuentas.",
  },
  expenses: {
    title: "Gastos registrados",
    body: "Gastos capturados en el módulo de Gastos con fecha de ese mes. Es la parte de las salidas que quedó documentada como gasto; lo que salió del banco por encima de esto es «salida sin registrar» (retiros, reversiones, pagos sin capturar).",
  },
  net: {
    title: "Neto del mes",
    body: "Entró − Salió. Si es positivo, ese mes el negocio acumuló dinero; si es negativo, salió más de lo que entró y la tesorería se encogió.",
  },
  balance: {
    title: "Saldo al cierre",
    body: "Dinero total en todas tus cuentas (pesos + dólares al tipo de cambio) al último día del mes. Para el mes en curso es el saldo de hoy.",
  },
  ratio: {
    title: "Gastos / entradas",
    body: "Qué porcentaje de lo que entró se fue en gastos registrados. Arriba de 70% es señal de alerta; arriba de 100% gastaste más de lo que entró ese mes.",
  },
  growth: {
    title: "Cambio del saldo vs mes anterior",
    body: "Cuánto cambió el saldo al cierre respecto al cierre del mes anterior, en porcentaje. Mide si la tesorería creció o se encogió como consecuencia de ese mes. El primer mes con datos no tiene referencia.",
  },
  unregistered: {
    title: "Salida sin registrar",
    body: "Lo que salió del banco menos los gastos registrados ese mes. Es dinero que salió de tus cuentas (retiros, devoluciones, pagos) sin un gasto capturado que lo explique. Si es alto, conviene revisar los movimientos del banco y registrar los gastos que falten.",
  },
  sales: {
    title: "Venta neta",
    body: "Suma de las notas de venta contabilizadas con fecha de ese mes: pagadas, o enviadas con al menos un abono. Las cotizaciones, borradores y notas canceladas no cuentan. Los dólares se convierten al tipo de cambio de Ajustes. Es la misma regla que el Dashboard financiero y el Reporte mensual.",
  },
  coverage: {
    title: "Salidas registradas como gasto",
    body: "Qué porcentaje de todo lo que salió del banco tiene un gasto registrado que lo respalda. 100% significa que cada peso que salió está documentado; mientras más bajo, más dinero salió sin explicación en el módulo de Gastos.",
  },
};

// Icono pequeño: al pasar el mouse o tocarlo explica qué significa el dato.
export default function InfoTip({ k, side = "top", className = "" }) {
  const [open, setOpen] = useState(false);
  const h = METRIC_HELP[k];
  if (!h) return null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Qué significa ${h.title}`}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
          className={`inline-flex items-center justify-center text-zinc-400 hover:text-[#002FA7] transition-colors ${className}`}
          data-testid={`info-${k}`}
        >
          <Info size={13} weight="bold" />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} align="start" className="w-72 p-3 text-xs leading-relaxed rounded-md border-zinc-200 shadow-lg font-body normal-case tracking-normal" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-testid={`info-${k}-content`}>
        <div className="font-heading font-extrabold text-sm text-zinc-900 mb-1">{h.title}</div>
        <div className="text-zinc-600">{h.body}</div>
      </PopoverContent>
    </Popover>
  );
}
